<div class="scorecard-description-linked-action" [ngClass]="{ 'margin-top-20': scorecardDescription.showLinkedScoreCard }">
  <ng-container *ngIf="scorecardDescription.isLocked">
    <div class="scorecard-description-locked">
      <div class="scorecard-description-locked-box">
        <span class="material-icons lock-icon">lock</span>
        <span class="scorecard-description-locked-box-text">{{ 'scorecard.locked.title' | translate }}</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="scorecardDescription.isCompleted">
    <div class="scorecard-description-congratulation-title">{{ 'scorecard.congratulation.title' | translate }}</div>
    <div class="scorecard-description-congratulation-subtitle">
      {{
        'scorecard.congratulation.subtitle' | translate: { scorecardName: scorecardDescription.currentScorecard.Content[0].Name }
      }}
    </div>
  </ng-container>

  <!--Scorecard Prize Box-->
  <ng-container *ngIf="scorecardDescription.isCompleted">
    <div class="scorecard-description-modal-prizebox">
      <!-- Has prize selection -->
      <ng-container *ngIf="hasPrizeSelection">
        <!-- Hasn't select prize yet -->
        <ng-container *ngIf="!scorecardDescription.currentScorecard?.PrizeOptions?.CustomerHasSelected">
          <fgbcl-scorecard-prize-selection
            [prizes]="scorecardDescription.currentScorecard.PrizeOptions?.Prizes"
            (onPrizeConfirmed)="onPrizeConfirmed($event)"
          ></fgbcl-scorecard-prize-selection>
        </ng-container>
        <!-- Selected Prize  -->
        <ng-container *ngIf="scorecardDescription.currentScorecard?.PrizeOptions?.CustomerHasSelected">
          <div class="scorecard-description-prizebox">
            <div class="scorecard-description-prize-selected">{{ 'scorecard.modal.prize.selected' | translate }}</div>
            <div class="scorecard-description-prize-selected-description">{{ prizeSelected }}</div>
          </div>
        </ng-container>
      </ng-container>
      <!-- No prize selection -->
      <ng-container *ngIf="!hasPrizeSelection">
        <div class="scorecard-description-prizebox">
          <div class="scorecard-description-prize">{{ 'scorecard.prize' | translate }}</div>
          <div class="scorecard-description-prize-description">
            {{ scorecardDescription.currentScorecard?.Content[0]?.PrizeDescription }}
          </div>
        </div>
        <fgbcl-social-share-modal
          shareType="scorecards"
          [itemId]="scorecardDescription.currentScorecard.ScorecardId"
          urlPage="scorecard-description"
          [loyaltyCategoryType]="loyaltyCategoryType"
        ></fgbcl-social-share-modal>
      </ng-container>

      <!-- Incomplete scorecard -->
      <ng-container *ngIf="!scorecardDescription.isCompleted">
        <div class="scorecard-description-modal-prize-v2">{{ 'scorecard.modal.prize.selection.options' | translate }}</div>
        <div
          class="scorecard-description-list-prize"
          *ngFor="let prizeOption of scorecardDescription.currentScorecard?.PrizeOptions?.Prizes"
        >
          <div class="scorecard-description-prize-option-title">
            {{ prizeOption.PrizeTitle }}
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="!scorecardCompletedNotSelectPrize">
    <ng-container
      *ngIf="
        scorecardDescription.showLinkedScoreCard &&
        (scorecardDescription.isCompleted || scorecardDescription.currentScorecard.Locked) &&
        !isLastChildUnlocked
      "
    >
      <ng-container *ngTemplateOutlet="nextChallengeUI; context: myContext"></ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template
  #nextChallengeUI
  let-label="label"
  let-image="image"
  let-name="name"
  let-invisibleIcon="invisibleIcon"
  let-redirectScorecard="redirectScorecard"
  let-description="description"
  let-isCompleted="isCompleted"
>
  <div class="scorecard-description-next-challenge">
    <div class="scorecard-description-next-challenge-label">{{ label | translate }}</div>
    <div class="scorecard-description-next-challenge-box" (click)="redirectScorecard()">
      <div class="scorecard-description-child-scorecard">
        <img
          class="scorecard-description-child-image"
          [ngClass]="{ 'scorecard-not-completed': !isCompleted }"
          src="{{ image | contentImage: '7' : 'badge' }} "
        />
        <div class="scorecard-description-child-scorecard-content">
          <div class="scorecard-description-child-name">{{ name }}</div>
          <div class="scorecard-description-child-description">{{ description }}</div>
        </div>
      </div>
      <span class="material-icons next-icon">chevron_right</span>
    </div>
  </div>
</ng-template>
